// import React, { useState } from 'react';
// import { useQuery, useMutation, useQueryClient } from 'react-query';
// import {
//   Box, Spinner, Text, Button, Table, Thead, Tbody, Tr, Th, Td,
//   Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter,
//   ModalBody, ModalCloseButton, useDisclosure, useToast
// } from '@chakra-ui/react';
// import axios from 'axios';
// import Api from '../../../api/ApiUrl';
// import CustomSpinner from '../../EndedAuctions/CustomSpinner';

// const fetchTransactions = async () => {
//   const response = await axios.get(`${Api}/api/v1/walletcontroller/transactions`);
//   console.log(response.data.transactions);
//   return response.data.transactions;
// };

// const deleteTransaction = async (transactionId) => {
//   const response = await axios.delete(`${Api}/api/v1/walletcontroller/transactions`, { data: { id: transactionId } });
//   return response.data;
// };

// const TransactionsManager = () => {
//   const queryClient = useQueryClient();
//   const toast = useToast();
//   const { isOpen, onOpen, onClose } = useDisclosure();
//   const [selectedTransaction, setSelectedTransaction] = useState(null);

//   const { data, isLoading, error } = useQuery('transactions', fetchTransactions);

//   const mutation = useMutation(deleteTransaction, {
//     onSuccess: () => {
//       queryClient.invalidateQueries('transactions');
//       toast({
//         title: 'Transaction deleted',
//         description: 'The transaction has been deleted successfully',
//         status: 'success',
//         duration: 3000,
//         isClosable: true,
//       });
//       onClose();
//     },
//     onError: (error) => {
//       toast({
//         title: 'An error occurred',
//         description: error.response?.data?.message || 'Unable to delete the transaction',
//         status: 'error',
//         duration: 3000,
//         isClosable: true,
//       });
//     },
//   });

//   const handleDelete = () => {
//     if (selectedTransaction) {
//       mutation.mutate(selectedTransaction._id);
//     }
//   };

//   if (isLoading) {
//     return <CustomSpinner />;
//   }

//   if (error) {
//     return <Box>Error loading transactions</Box>;
//   }

//   return (
//     <Box p={5} shadow="md" borderWidth="1px">
//       <Text fontSize="xl" mb={4}>Transactions</Text>
//       <Table variant="simple">
//         <Thead>
//           <Tr>
//             <Th>User Name</Th>
//             <Th>Phone Number</Th>
//             <Th>Amount</Th>
//             <Th>Type</Th>
//             <Th>Description</Th>
//             <Th>Admin</Th>
//             <Th>Created at</Th>
//             <Th>Action</Th>

//           </Tr>
//         </Thead>
//         <Tbody>
//           {data.map(transaction => (
//             <Tr key={transaction?._id} color={transaction?.type === 'deposit' ? 'green' : 'red'}>
//               <Td>{transaction?.userId?.name}</Td>
//               <Td>{transaction?.userId?.phoneNumber}</Td>
//               <Td>{transaction?.amount}</Td>
//               <Td >{transaction?.type}</Td>
//               <Td>{transaction?.description}</Td>
//               <Td>{transaction?.adminId?.username}</Td>
//               <Td>{new Date(transaction?.createdAt).toLocaleString()}</Td>

//               <Td>
//                 <Button colorScheme="red" onClick={() => { setSelectedTransaction(transaction); onOpen(); }}>
//                   Delete
//                 </Button>
//               </Td>
//             </Tr>
//           ))}
//         </Tbody>
//       </Table>

//       <Modal isOpen={isOpen} onClose={onClose}>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>Confirm Delete</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             Are you sure you want to delete this transaction?
//           </ModalBody>
//           <ModalFooter>
//             <Button colorScheme="blue" mr={3} onClick={handleDelete}>
//               Yes
//             </Button>
//             <Button variant="ghost" onClick={onClose}>Cancel</Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>
//     </Box>
//   );
// };

// export default TransactionsManager;


import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import {
  Box, Spinner, Text, Button, Table, Thead, Tbody, Tr, Th, Td,
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter,
  ModalBody, ModalCloseButton, useDisclosure, useToast, Input
} from '@chakra-ui/react';
import axios from 'axios';
import Api from '../../../api/ApiUrl';
import CustomSpinner from '../../EndedAuctions/CustomSpinner';

const fetchTransactions = async () => {
  const response = await axios.get(`${Api}/api/v1/walletcontroller/transactions`);
  console.log(response.data.transactions);
  return response.data.transactions;
};

const deleteTransaction = async (transactionId) => {
  const response = await axios.delete(`${Api}/api/v1/walletcontroller/transactions`, { data: { id: transactionId } });
  return response.data;
};

const TransactionsManager = () => {
  const queryClient = useQueryClient();
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const { data, isLoading, error } = useQuery('transactions', fetchTransactions);

  const mutation = useMutation(deleteTransaction, {
    onSuccess: () => {
      queryClient.invalidateQueries('transactions');
      toast({
        title: 'Transaction deleted',
        description: 'The transaction has been deleted successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      onClose();
    },
    onError: (error) => {
      toast({
        title: 'An error occurred',
        description: error.response?.data?.message || 'Unable to delete the transaction',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    },
  });

  const handleDelete = () => {
    if (selectedTransaction) {
      mutation.mutate(selectedTransaction._id);
    }
  };

  if (isLoading) {
    return <CustomSpinner />;
  }

  if (error) {
    return <Box>Error loading transactions</Box>;
  }

  // Filter transactions based on search query
  const filteredTransactions = data?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) ?.filter(transaction => 
    transaction?.userId?.phoneNumber.includes(searchQuery)
  );

  return (
    <Box p={5} shadow="md" borderWidth="1px">
      <Text fontSize="xl" mb={4}>Transactions</Text>
      
      {/* Search Bar */}
      <Input 
        placeholder="Search by phone number"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        mb={4}
      />

      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>User Name</Th>
            <Th>Phone Number</Th>
            <Th>Amount</Th>
            <Th>Type</Th>
            <Th>Description</Th>
            <Th>Admin</Th>
            <Th>Created at</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {filteredTransactions.map(transaction => (
            <Tr key={transaction?._id} color={transaction?.type === 'deposit' ? 'green' : 'red'}>
              <Td>{transaction?.userId?.name}</Td>
              <Td>{transaction?.userId?.phoneNumber}</Td>
              <Td>{transaction?.amount}</Td>
              <Td>{transaction?.type}</Td>
              <Td>{transaction?.description}</Td>
              <Td>{transaction?.adminId?.username}</Td>
              <Td>{new Date(transaction?.createdAt).toLocaleString()}</Td>
              <Td>
                <Button colorScheme="red" onClick={() => { setSelectedTransaction(transaction); onOpen(); }}>
                  Delete
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirm Delete</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Are you sure you want to delete this transaction?
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleDelete}>
              Yes
            </Button>
            <Button variant="ghost" onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TransactionsManager;
